module.exports = {"id":"17605","name":"Timmy Simons","rating":"72","photo":"./data/images/photos/1/17605.png","club":{"name":"Club Bruges","logo":"./data/images/clubs/ClubBruges.png"},"positions":["MDC","MC","DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimmySimons0.json
// module id = 4138
// module chunks = 0